import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const KEY = "ncl_member";
const Ctx = createContext({ member: null, setMember: () => {}, clearMember: () => {} });

export function MemberProvider({ children }) {
  const [member, setMemberState] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (_) { return null; }
  });

  const setMember = useCallback((m) => {
    setMemberState(m);
    try { localStorage.setItem(KEY, JSON.stringify(m)); } catch (_) {}
  }, []);

  const clearMember = useCallback(() => {
    setMemberState(null);
    try { localStorage.removeItem(KEY); } catch (_) {}
  }, []);

  const value = useMemo(() => ({ member, setMember, clearMember }), [member, setMember, clearMember]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useMember() { return useContext(Ctx); }
